// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__VBwra","button":"style_button__7A0Kb"};